import { ServiceComboTargetClientele } from "@/Common/Models/Services/Enums/ServiceComboTargetClientele";

class PredefinedSendingModel {
    public Duration: number;
    public StartDate: Date;
    public ServiceDefinitionId: string;
    public IsOnlineBookingAllowed: boolean;
    public TargetedClient: ServiceComboTargetClientele;
}

export { PredefinedSendingModel };
